const NATIVE_CHECKOUT_FLAG = 'native-checkout'

export function markNativeCheckoutSession(): void {
  try {
    sessionStorage.setItem(NATIVE_CHECKOUT_FLAG, '1')
  } catch {
    // sessionStorage can throw in private mode
  }
}

export function isNativeCheckoutSession(): boolean {
  try {
    return sessionStorage.getItem(NATIVE_CHECKOUT_FLAG) === '1'
  } catch {
    return false
  }
}

export function clearNativeCheckoutSession(): void {
  try {
    sessionStorage.removeItem(NATIVE_CHECKOUT_FLAG)
  } catch {
    // ignore
  }
}

export function nativeCheckoutReturnUrl(pkgId: string, status: 'paid' | 'cancelled'): string {
  const params = new URLSearchParams({ pkgId, status })
  return `com.shiptanbul.app://native-return?${params.toString()}`
}

/** Safari on the same host will not fire Universal Links — use the custom scheme. */
export function redirectNativeCheckoutReturn(pkgId: string, status: 'paid' | 'cancelled'): boolean {
  if (!isNativeCheckoutSession()) return false
  clearNativeCheckoutSession()
  window.location.assign(nativeCheckoutReturnUrl(pkgId, status))
  return true
}
